import { POINTS_CASH_OUT_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { POINTS_CASH_OUT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { minPayoutAmount } from 'root/src/shared/constants/pointsCashOut'
import { formatNumberWithCommas } from 'root/src/shared/util/formatNumberWithCommas'
import { events } from 'root/src/shared/constants/analytics'
import analyticsSendItem from 'root/src/client/logic/analytics/util/analyticsSendItem'
import userIdSelector from 'root/src/client/logic/auth/selectors/userIdSelector'

export default {
	[POINTS_CASH_OUT_MODAL_MODULE_ID]: {
		moduleType: 'modal',
		modalTitle: 'SUBMIT YOUR POINTS',
		modalText: 'READY TO SUBMIT?',
		modalContent: {
			noticeText:
				'**The money will be deposited into your paypal account\n within 7 days of processing**',
			buttons: [
				{
					buttonText: 'CANCEL',
					type: 'cancel',
					onClickFn: ({ displayModal }) => { //
						displayModal(undefined)
					},
				},
				{
					buttonText: 'SUBMIT',
					onClickFn: async ({
						displayModal,
						setError,
						apiRequest,
						creatorPoints,
						// eslint-disable-next-line consistent-return
					}) => {
						if (creatorPoints < 50000) {
							return setError(
								`Minimal amount of points to payout equals to ${formatNumberWithCommas(
									minPayoutAmount,
								)}`,
							)
						}
						const { error } = await apiRequest(POINTS_CASH_OUT, {})
						if (error) {
							return setError(error.message)
						}
						const userId = userIdSelector()
						analyticsSendItem(events.pointsCashOut, userId)
						displayModal(undefined)
					},
				},
			],
		},
	},
}
